module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pixel-header pixel-1px-b"
  }, [_c('div', {
    staticClass: "pixel-header-left"
  }, [_vm._t("overwrite-left", [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._leftOptions.showBack),
      expression: "_leftOptions.showBack"
    }],
    staticClass: "pixel-header-back",
    on: {
      "click": _vm.onClickBack
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOpyions.backText) + "\n\t\t\t\t")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._leftOptions.showBack),
      expression: "_leftOptions.showBack"
    }],
    staticClass: "left-arrow",
    on: {
      "click": _vm.onClickBack
    }
  })])]), _vm._v(" "), _vm._t("left")], 2), _vm._v(" "), _c('h1', {
    staticClass: "pixel-header-title"
  }, [_vm._t("default", [_c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.title),
      expression: "title"
    }]
  }, [_vm._v(_vm._s(_vm.title))])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "pixel-header-right"
  }, [(_vm.rightOptions.showMore) ? _c('a', {
    staticClass: "pixel-header-more",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$emit('on-click-more')
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("right")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-731a0fe3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PHeader/PHeader.vue
// module id = 253
// module chunks = 3